// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loading_loaderContainer__cMHEh","loader":"Loading_loader__3oRzJ","load8":"Loading_load8__1mGq-"};